import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from '../locales/en.json';
import viTranslations from '../locales/vi.json';
import deTranslations from '../locales/de.json';
import itTranslations from '../locales/it.json';
import thTranslations from '../locales/th.json';
import arTranslations from '../locales/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      vi: {
        translation: viTranslations
      },
      de: {
        translation: deTranslations
      },
      it: {
        translation: itTranslations
      },
      th: {
        translation: thTranslations
      },
      ar: {
        translation: arTranslations
      }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    pluralSeparator: '_'
  });

export default i18n;
